// Which interface someone gets. Same code and routes either way; only the
// frame differs (bottom tabs for phones in the field, sidebar for the office).
//   - the Android app is the field shell for anyone who works in the field
//   - in a browser, anyone with office access gets the office shell
//   - a field-only user in a browser still gets the field shell
// A saved choice wins when the user is allowed both.
export function chooseShell({ capabilities = [], native = false, saved = null }) {
  const field = capabilities.includes('field.use');
  const office = capabilities.includes('office.use');
  if (field && office && (saved === 'field' || saved === 'office')) return saved;
  if (native) return field ? 'field' : 'office';
  if (office) return 'office';
  return 'field';
}
